<template>
    <div id="navbar-mobile">
        <div class="menu-navbar">
            <div class="logo">
                <router-link to="/" >
                    <img :src="logo" alt="logo" @click="closeSidebar">
                </router-link>
            </div>
            <div class="menu">
                <div class="search">
                    <i class="fas fa-search"></i>
                    <router-link to="/map">
                        <img :src="miniMap" alt="miniMap" @click="closeSidebar">
                    </router-link>
                    <i class="fas fa-bars" @click="sideActive = !sideActive; dropdownOpen = 0;"></i>
                </div>
            </div>
        </div>
        <div class="side-menu" :class="{isActive : sideActive}">
            <VuePerfectScrollbar class="scroll-area">
            <ul class="list-menu">
                <router-link to="/snapshots" tag="li">
                    <div @click="closeSidebar">
                        Traveler Snapshots
                    </div>
                </router-link>
                <li @click="openDropdown(1)">
                    Travel Themes 
                    <i class="fas fa-chevron-down" :class="{isActive : (dropdownOpen == 1)?true:false}"></i>
                </li>
                <ul class="dropdown" :class="{isActive : (dropdownOpen == 1)?true:false}" @click="closeSidebar">
                    <router-link :to="'/themes/'+item.link" tag="li" v-for="(item, index) in dropdown1" :key="index" :style="item.style">{{item.name}}</router-link>
                </ul>
                <li @click="openDropdown(2)">
                    Regions 
                    <i class="fas fa-chevron-down" :class="{isActive : (dropdownOpen == 2)?true:false}"></i>
                </li>
                <ul class="dropdown" :class="{isActive : (dropdownOpen == 2)?true:false}" @click="closeSidebar">
                    <router-link :to="`${item.link}`" tag="li" v-for="(item, index) in dropdown2" :key="index" :style="item.style">{{item.name}}</router-link>
                </ul>
                <li @click="openDropdown(3)">
                    Plan Your Trip 
                    <i class="fas fa-chevron-down" :class="{isActive : (dropdownOpen == 3)?true:false}"></i>
                </li>
                <ul class="dropdown" :class="{isActive : (dropdownOpen == 3)?true:false}" @click="closeSidebar">
                    <router-link :to="`${item.link}`" tag="li" v-for="(item, index) in dropdown3" :key="index" :style="item.style">{{item.name}}</router-link>
                </ul>
                <!-- <router-link to="/offers" tag="li">
                    <div @click="closeSidebar">
                        Offers
                    </div>
                </router-link> -->
                <router-link to="/events" tag="li">
                    <div @click="closeSidebar">
                        Events
                    </div>
                </router-link>
                <!-- <router-link to="/regions" tag="li">
                    <div @click="closeSidebar">
                        Contact
                    </div>
                </router-link> -->
                <router-link to="/map" tag="li">
                    <div @click="closeSidebar">
                        Map
                    </div>
                </router-link>
            </ul>
            </VuePerfectScrollbar>
        </div>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import logo from '../assets/img/logo.png'
import miniMap from '../assets/img/mini-map.png'

export default {
    name : 'navbar-mobile',
    components: {
        VuePerfectScrollbar
    },
    data() {
        return {
            logo : logo,
            miniMap : miniMap,
            sideActive : false,
            dropdownOpen : 0,
            dropdown1: [
                {
                    name: 'Festivals',
                    link: 'festivals',
                    style: {
                        'color' : '#FFFFFF',
                        'background-color': '#E13036',
                    }
                },
                {
                    name: 'Family Activities',
                    link: 'family',
                    style: {
                        'color' : '#FFFFFF',
                        'background-color': '#34679F',
                    }
                },
                {
                    name: 'Nature',
                    link: 'nature',
                    style: {
                        'color' : '#FFFFFF',
                        'background-color': '#D57504',
                    }
                },
                {
                    name: 'Bird Watching',
                    link: 'bird-watching',
                    style: {
                        'color' : '#FFFFFF',
                        'background-color': '#228B5B',
                    }
                },
                {
                    name: 'History & Culture',
                    link: 'history',
                    style: {
                        'color' : '#FFFFFF',
                        'background-color': '#10523B',
                    }
                },
                {
                    name: 'Buddhist Tourism',
                    link: 'buddhist-tourism',
                    style: {
                        'color' : '#FFFFFF',
                        'background-color': '#D59D04',
                    }
                },
                {
                    name: 'Taste of Mongolia',
                    link: 'taste',
                    style: {
                        'color' : '#FFFFFF',
                        'background-color': '#5F120F',
                    }
                },
                {
                    name: 'Community Based Tourism',
                    link: 'community-based-tourism',
                    style: {
                        'color' : '#FFFFFF',
                        'background-color': '#911457',
                    }
                },
                {
                    name: 'Adventure',
                    link: 'adventure',
                    style: {
                        'color' : '#FFFFFF',
                        'background-color': '#340A4E',
                    }
                },
                {
                    name: 'MICE',
                    link: 'mice',
                    style: {
                        'color' : '#FFFFFF',
                        'background-color': '#222F6A',
                    }
                },
            ],
            dropdown2: this.$store.state.ref.locations.map(it => (
                {
                    name: it.shortTitle || it.title,
                    link: `/regions/${it.alias}`,
                    style: {
                        'color' : it.color,
                        'background-color': it.bgColor,
                    }
                }
            )),
            dropdown3: [
                {
                    name : 'Getting to Mongolia',
                    link : "/plan/getting-to-mongolia",
                    style: {
                        'color' : '#E02F35',
                        'background-color': 'rgba(224,47,53, .13)',
                    }
                },
                {
                    name : 'Travel Around',
                    link : "/plan/travel-around",
                    style: {
                        'color' : '#E02F35',
                        'background-color': 'rgba(224,47,53, .13)',
                    }
                },
                {
                    name : 'Customs & Culture',
                    link : "/plan/customs-culture",
                    style: {
                        'color' : '#E02F35',
                        'background-color': 'rgba(224,47,53, .13)',
                    }
                },
                {
                    name : 'Practical Information',
                    link : "/plan/practical-information",
                    style: {
                        'color' : '#E02F35',
                        'background-color': 'rgba(224,47,53, .13)',
                    }
                },
            ]
        }
    },
    methods: {
        openDropdown(num) {
            if (this.dropdownOpen == num) {
                this.dropdownOpen = 0;
            } else {
                this.dropdownOpen = num;
            }
        },
        closeSidebar() {
            this.sideActive = false; 
            this.dropdownOpen = 0;
        }
    }
}
</script>

<style lang="scss" scoped>
    #navbar-mobile {
        background-color: #E13036;
        position: fixed;
        width: 100%;
        z-index: 1004;
        .menu-navbar {
            display: flex;
            align-items: center;

            .logo {
                padding: 6px 15px;
            }

            .menu {
                width: 100%;
                display: flex;
                justify-content: flex-end;
                .search {
                    font-size: 25px;
                    color: #FFFFFF;
                    text-align: right;

                    .fa-search,.fa-bars {
                        cursor: pointer;
                        margin: 0 20px;
                    }

                    img {
                        cursor: pointer;
                    }
                }
            }
        }
        
        .side-menu {
            position: absolute;
            right: -73.33%;
            width: 73.33%;
            height: 100vh;
            transition: .2s ease;
            background-color: #FFFFFF;

            &.isActive {
                right: 0;
            }

            .list-menu {
                list-style: none;
                padding: 0;

                >li {
                    padding: 15px 25px;
                    color: #E13036;
                    font-size: 18px;
                    font-weight: bold;
                    border-bottom: 2px #E6E6E6 solid;
                    position: relative;
                    i {
                        color: #000000;
                        position: absolute;
                        top: 20px;
                        right: 10px;

                        &.isActive {
                            transform: rotate(180deg);
                        }
                    }
                }
            }

            .dropdown {
                list-style: none;
                padding: 0;
                display: none;

                &.isActive {
                    display: block;
                }

                >li {
                    width: 100%;
                    padding: 10px 0 10px 35px;
                    font-size: 15px;
                    font-weight: bold;
                    border-bottom: #FFFFFF 1px solid;
                }
            }

            .scroll-area {
                position: relative;
                height: 85vh;
            }
        }
        
    }
</style>

